<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>各種書類</span>
      <el-button style="float: right; padding: 3px 0" @click="top" type="text">戻る</el-button>
    </div>
    <div class="table-area">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>カテゴリー</th>
            <th>書類名</th>
            <th>書類概要</th>
            <th>ダウンロード</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in documents" :key="index">
            <td>{{ row.category_name }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.description }}</td>
            <td class="text-center">
              <a :href="row.download_url" download>
                <i class="el-icon-download"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      documents: []
    }
  },
  mounted: function () {
    this.initialize()
  },
  methods: {
    top() {
      this.transitionSame('top')
    },
    initialize() {
      axios.get('/api/store/documents').then((res) => {
        this.documents = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  td {
    a {
      i {
        font-size: 15px;
      }
    }
  }
}
</style>
